// removed by extract-text-webpack-plugin
module.exports = {"content":"Content-content-RXvNG","left":"Content-left-1MDLl","center":"Content-center-3Ly6d","right":"Content-right-EqBTg","justify":"Content-justify-2fSl_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Content/Content.css
// module id = ./src/components/Content/Content.css
// module chunks = 0